// extracted by mini-css-extract-plugin
module.exports = {"logo":"Logo_logo__2Fm4M","md":"Logo_md__29JdR","lg":"Logo_lg__2l4fo"};